var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M21 20a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zM15.707 2.293l4 4a1 1 0 0 1 0 1.414l-10 10A1 1 0 0 1 9 18H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l10-10a1 1 0 0 1 1.414 0z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }